export enum LoadingIndicatorSize {
  small = 's',
  medium = 'm',
  large = 'l',
}

export enum LoadingIndicatorVariant {
  primary = 'primary',
  positive = 'positive',
  invertedPrimary = 'invertedPrimary',
  persistentLight = 'persistentLight',
}

// ariaLabel and ariaLabelledBy optional props will be force to be passed as props in this ticket: https://glovoapp.atlassian.net/browse/PTXO-2018
export interface LoadingIndicatorProps {
  'aria-label'?: string
  'aria-labelledby'?: string
  className?: string
  size?: LoadingIndicatorSizeType
  variant?: LoadingIndicatorVariantType
}

export type LoadingIndicatorSizeType = `${LoadingIndicatorSize}`
export type LoadingIndicatorVariantType = `${LoadingIndicatorVariant}`
